const SNAPSHOT_KEY = "performance-tracker-snapshot";

const LIVE = ["RUNNING", "PAUSED", "AUTO_PAUSED"];

export function isLiveTrackerStatus(status) {
  return LIVE.includes(status);
}

export function loadTrackerSnapshot() {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const parsed = JSON.parse(sessionStorage.getItem(SNAPSHOT_KEY));
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
    if (!parsed.status) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveTrackerSnapshot(state) {
  if (typeof sessionStorage === "undefined" || !state || typeof state !== "object") return;
  try {
    sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(state));
  } catch {
    /* quota / private mode */
  }
}

export function clearTrackerSnapshot() {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(SNAPSHOT_KEY);
}
